module.exports = __webpack_public_path__ + "static-portal/img/new8-4.425695b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new8-4.png
// module id = 0phy
// module chunks = 4